export const SizeVariants = {
  full: 'col-span-6 sm:col-span-full',
  '1/2': 'col-span-6 sm:col-span-3',
  '1/3': 'col-span-6 sm:col-span-2',
}
